import { FilterMetadata } from 'primeng/api/filtermetadata';
import { FilterMatchMode } from 'primeng/api';
import { ShipmentStatusType } from './shipment-status-type.enum';

export class ShipmentTrackingFilters {
  orderNumber: FilterMetadata = {
    value: '',
    matchMode: 'contains',
  };
  shipmentSeries: FilterMetadata = {
    value: '',
    matchMode: 'contains',
  };
  pickupCompany: FilterMetadata = {
    value: '',
    matchMode: 'contains',
  };
  deliveryCompany: FilterMetadata = {
    value: '',
    matchMode: 'contains',
  };
  pickupCity: FilterMetadata = {
    value: '',
    matchMode: 'contains',
  };
  deliveryCity: FilterMetadata = {
    value: '',
    matchMode: 'contains',
  };
  pickupNamedLocationUuid: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.IN,
  };
  deliveryNamedLocationUuid: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.IN,
  };
  pickupWindowStart: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.GREATER_THAN,
  };
  deliveryWindowEnd: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.LESS_THAN,
  };
  externalReference: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  };
  costCenterLabel: FilterMetadata = {
    value: null,
    matchMode: 'contains',
  };
  packageId: FilterMetadata = {
    value: '',
    matchMode: FilterMatchMode.CONTAINS,
  };
  currentStatus: FilterMetadata = {
    value: Object.values(ShipmentStatusType),
    matchMode: FilterMatchMode.IN,
  };
}
